$('.details-restaurant__slider-list').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  mobileFirst: true,
});
  